<template>
   <section></section>
</template>

<script>
export default {
   data () {
      return {

      };
   },

   components: {},

   mounted() {},

   methods: {}
}
</script>
<style lang='scss' scoped>

</style>